/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, action: NonNullable<unknown> }} Seo_Endpoint_Q_FreeInputs */

const en_seo_endpoint_q_free = /** @type {(inputs: Seo_Endpoint_Q_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Can I try the ${i?.name} ${i?.action} API for free?`)
};

const zh_hans1_seo_endpoint_q_free = /** @type {(inputs: Seo_Endpoint_Q_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action} API 可以免费试用吗？`)
};

const pt_br2_seo_endpoint_q_free = /** @type {(inputs: Seo_Endpoint_Q_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Posso testar grátis o endpoint ${i?.action} da API para ${i?.name}?`)
};

const es_seo_endpoint_q_free = /** @type {(inputs: Seo_Endpoint_Q_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Puedo probar gratis el endpoint ${i?.action} de la API de ${i?.name}?`)
};

const fr_seo_endpoint_q_free = /** @type {(inputs: Seo_Endpoint_Q_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Puis-je essayer l’API ${i?.name} ${i?.action} gratuitement ?`)
};

const de_seo_endpoint_q_free = /** @type {(inputs: Seo_Endpoint_Q_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kann ich die ${i?.name}-${i?.action}-API kostenlos testen?`)
};

const ru_seo_endpoint_q_free = /** @type {(inputs: Seo_Endpoint_Q_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Можно ли попробовать API ${i?.name} ${i?.action} бесплатно?`)
};

const it_seo_endpoint_q_free = /** @type {(inputs: Seo_Endpoint_Q_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Posso provare gratis l'API ${i?.name} ${i?.action}?`)
};

/**
* | output |
* | --- |
* | "Can I try the {name} {action} API for free?" |
*
* @param {Seo_Endpoint_Q_FreeInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_q_free = /** @type {((inputs: Seo_Endpoint_Q_FreeInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_Q_FreeInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_q_free(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_q_free(inputs)
	if (locale === "es") return es_seo_endpoint_q_free(inputs)
	if (locale === "fr") return fr_seo_endpoint_q_free(inputs)
	if (locale === "de") return de_seo_endpoint_q_free(inputs)
	if (locale === "ru") return ru_seo_endpoint_q_free(inputs)
	if (locale === "it") return it_seo_endpoint_q_free(inputs)
	return en_seo_endpoint_q_free(inputs)
});